angular.module('ui.report.reportViewer', [])

    .directive('reportViewer', function () {
        return {
            restrict: 'E',
            templateUrl: 'app/ui/report/reportViewer/reportViewer.html',
            scope: {},
            controller: 'ReportViewerController',
            controllerAs: 'ReportViewerController'
        }
    })

    .controller('ReportViewerController', function ($scope, $rootScope, $q, $sce, $http, $interval, gettextCatalog,
                                                    authService, reportManager, orderItemsGridSharedSettings, gridDataProvider,
                                                    usersRepository, workflowRepository, $customisationConfig,
                                                    serverLocalization, uiLocalization, $state, $timeout) {

        var rootReportApi = om.config.build.baseUrl + "/report";

        $scope.isBusy = true;
        $rootScope.pageTitle = 'OrderManager: Report: ' + reportManager.getReportConfig().report.name + '(' + reportManager.getReportConfig().report.reportFileName + ')';

        var loadingHtml = $sce.trustAsHtml("<div class='loading'>" + gettextCatalog.getString("Loading...") + "</div>");
        var reportConfig = reportManager.getReportConfig();
        var reportQuery = (reportConfig.query || reportConfig.report.query);

        //Double-check if the report was configured with dynamic query (function) and try to evaluate it
        //passing the grid's query. Unfortunately we can't acquire selected item referece here, so omitting it.
        if (angular.isFunction(reportQuery)) {
            reportQuery = reportQuery(gridDataProvider.getReportQuery());
        }

        //See if the resulted report query is array of element IDs or not. 
        //If it is a string, we have to wrap it with double-quotes, otherwise - not.
        if (!_.isArray(reportQuery)) {
            reportQuery = '"' + reportQuery + '"';
        } else {
            reportQuery = '' + JSON.stringify(reportQuery) + '';
        }

        $scope.request = {
            "ReportName": reportConfig.report.reportFileName,
            "Query": reportQuery,
            //we use either specific custom query of the report specified in customisation or 
            //just the query that is used to show the current data set user is being viewing at
            //query and orderBy from report specified in customisation have higher priority over current-context data
            "OrderBy": reportConfig.report.orderBy || reportConfig.orderBy,
            "Format": "Html",
            "BaseEntityName": reportConfig.report.baseEntityName
        };

        $scope.dataSource = new kendo.data.DataSource({
            data: [],
            pageSize: 1
        });

        $scope.exportOptions = {
            dataSource: [
                {text: gettextCatalog.getString("Pdf"), value: "Pdf", selected: true},
                {text: gettextCatalog.getString("Xls"), value: "Xls"},
                {text: gettextCatalog.getString("Xlsx"), value: "Xlsx"},
                {text: gettextCatalog.getString("Rtf"), value: "Rtf"},
                {text: gettextCatalog.getString("Mht"), value: "Mht"},
                {text: gettextCatalog.getString("Html"), value: "Html"},
                {text: gettextCatalog.getString("Text"), value: "Text"},
                {text: gettextCatalog.getString("Csv"), value: "Csv"},
                {text: gettextCatalog.getString("Image"), value: "Image"}

            ],
            dataTextField: "text",
            dataValueField: "value"
        };

        $scope.exportFormat = "Pdf";

        $scope.enableToolbar = function (enable) {
            $scope.isBusy = !enable;
        };

        $scope.step = orderItemsGridSharedSettings.getStepFilter() || 'all-open';
        initStepHeader();

        $scope.exportItems = {
            items: [
                {
                    template: "<a ng-click='moveUp(documentId)' class='order-state-link back-to-state' title='{{stateDisplayName}}'><span om-spinner size='0.6em' class='loading-spinner long-fade long-fade-in animation-v-align' ng-class='{out:(stateDisplayName && progress >= 100)}'></span><div ng-show='stateIconName' custom-background='{{stateIconName}}' class='order-state-link-icon fade fade-out' ng-class='{in:(stateDisplayName && progress >= 100)}'></div><div class='order-state-link-text fade fade-out' ng-class='{in:stateDisplayName}'>{{stateDisplayName}}</div><span class='fa fa-lg fa-level-up a-fa-btn'></span></a>",
                    overflow: "never"
                },
                {type: "separator"},
                {
                    template: "<div kendo-pager='pager' id='report-pager' k-data-source='dataSource' k-numeric='false' k-info='false' k-input='true' k-on-change='onPageChange(this)'></div>",
                    overflow: "never"
                },
                {type: "separator"},
                {
                    template: "<input kendo-drop-down-list k-options='exportOptions' style='width: 10em;' ng-model='exportFormat' />",
                    overflow: "never"
                },
                {
                    type: "button",
                    attributes: {"title": gettextCatalog.getString("Export a report and save it to the disk")},
                    spriteCssClass: "icon-save",
                    id: "saveExport"
                },
                {
                    type: "button",
                    attributes: {"title": gettextCatalog.getString("Export a report and show it in a new window")},
                    spriteCssClass: "icon-save-page",
                    id: "showExport"
                },
                {type: "separator"},
                {
                    type: "button",
                    attributes: {"title": gettextCatalog.getString("PrintReport")},
                    spriteCssClass: "icon-print",
                    id: "printExport"
                },
                {
                    type: "button",
                    attributes: {"title": gettextCatalog.getString("PrintCurrentPage")},
                    spriteCssClass: "icon-print-page",
                    id: "printExportPage"

                }
            ],
            click: function (e) {
                switch (e.id) {
                    case "printExportPage":
                    case "printExport":
                    {
                        $scope.enableToolbar(false);
                        var firstPage = (e.id == "printExportPage" ? $scope.pager.page() - 1 : 0);
                        var lastPage = (e.id == "printExportPage"
                            ? firstPage
                            : $scope.dataSource.data().length - 1);
                        $scope.getReportDocument($scope.documentId, "Html", firstPage, lastPage, null).
                            then(function (data) {
                                var printFrame = $('#print_frame');
                                var contentWindow = printFrame[0].contentWindow;
                                printFrame.contents().find('html').html(data);
                                contentWindow.focus(); //for IE
                                if (navigator.userAgent.toLowerCase().indexOf('msie') != -1
                                    || navigator.userAgent.toLowerCase().indexOf('edge') != -1
                                    || navigator.userAgent.toLowerCase().indexOf('trident') != -1) {
                                    contentWindow.document.execCommand('print', false, null);
                                } else {
                                    contentWindow.print();
                                }

                                //window.frames["print_frame"].window.focus(); //for IE
                                //window.frames["print_frame"].window.print();
                                $timeout(function () {
                                    $scope.enableToolbar(true);
                                });

                                //$('#print_frame').contents().find('html').html(data);
                                //window.frames["print_frame"].document.body.innerHTML=data;

                            }, function (reason) {
                                $timeout(function () {
                                    $scope.enableToolbar(true);
                                });
                                if (reason && 'FullException' in reason) alert(reason.FullException);
                            });
                        break;
                    }
                    case "saveExport":
                    {

                        $scope.enableToolbar(false);
                        var form = $('<form method="POST" action="' + rootReportApi + '/document" target="iframe_target" style="display:none"><iframe id="iframe_target" name="iframe_target" src="about:blank"></iframe>');
                        var params = {
                            DocumentId: $scope.documentId,
                            Format: $scope.exportFormat,
                            FirstPage: 0,
                            LastPage: $scope.dataSource.data().length - 1,
                            ContentDisposition: "attachment",
                            Authorization: authService.getToken()
                        };
                        $.each(params, function (k, v) {
                            form.append($('<input type="hidden" name="' + k +
                                '" value="' + v + '">'));
                        });
                        $('body').append(form);
                        var document = $(window)[0].document;
                        //document.cookie = "Authorization=" + authService.getToken() + "; path=/";
                        document.cookie = "OMVersion=" + authService.omVersion + "; path=/";
                        var options = {};

                        form.submit(function () {
                            $scope.enableToolbar(true);
                        });
                        form.submit();
                        break;
                    }
                    case "showExport":
                    {
                        $scope.enableToolbar(false);

                        var wnd = window.open("about:blank", "reportExport", "width=800.height=600");
                        var form = $('<form method="POST" action="' + rootReportApi + '/document" target="blank">');
                        var params = {
                            DocumentId: $scope.documentId,
                            Format: $scope.exportFormat,
                            FirstPage: 0,
                            LastPage: $scope.dataSource.data().length - 1,
                            ContentDisposition: "inline",
                            Authorization: authService.getToken()
                        };
                        $.each(params, function (k, v) {
                            form.append($('<input type="hidden" name="' + k +
                                '" value="' + v + '">'));
                        });
                        $('body').append(form);
                        var document = $(window)[0].document;
                        //document.cookie = "Authorization=" + authService.getToken() + "; path=/";
                        document.cookie = "OMVersion=" + authService.omVersion + "; path=/";
                        var options = {};
                        form.attr('target', 'reportExport');
                        form.submit(function () {
                            $scope.enableToolbar(true);
                        });

                        form.submit();
                        break;
                    }

                }
            }
        };

        $scope.onPageChange = function () {
            $scope.enableToolbar(false);
            var page = $scope.pager.page() - 1;
            $scope.content = loadingHtml;
            $scope.getReportDocument($scope.documentId, "Html", page, page, null)
                .then(function (data) {
                    $scope.content = $sce.trustAsHtml("<div id='report-pages'>" + data + "</div>");
                    $scope.enableToolbar(true);
                }, function (reason) {
                    $scope.enableToolbar(true);
                    if (reason && 'FullException' in reason) alert(reason.FullException);
                });
        };

        $scope.onActivate = function () {
            $scope.enableToolbar(false);
            $scope.content = loadingHtml;
            $scope.dataSource.data([]);
            $scope.buildReport()
                .then(function (data) {
                    $scope.content = $sce.trustAsHtml("<div id='report-pages'>" + data + "</div>");
                    $scope.enableToolbar(true);


                }, function (reason) {
                    $scope.enableToolbar(true);
                    if (reason && 'FullException' in reason) alert(reason.FullException);
                });
        };

        $scope.buildReport = function () {
            $scope.cancelled = false;
            $scope.building = true;
            $scope.progress = 0;
            var deferred = $q.defer();

            $http({
                "url": rootReportApi + "/build",
                "method": "POST",
                "data": $scope.request,
                "headers": {"Content-Type": "application/json"}
            })
                .success(function (data, status, headers, config) {

                })
                .error(function (data, status, headers, config) {
                    if (status == 401) {
                        deferred.reject();
                    } else {
                        deferred.reject(data);
                    }
                    $scope.building = false;
                }).then(function (data) {
                    var error = null;
                    $scope.documentId = data.data.documentId;
                    var interval = $interval(function () {
                        if (error != null || $scope.cancelled) {
                            deferred.reject(error);
                            $interval.cancel(interval);
                            $scope.building = false;
                            if ($scope.cancelled) $scope.content = $sce.trustAsHtml("<div class='loading'>Cancelled</div>");

                        } else if ($scope.progress >= 100) {
                            $scope.getReportDocument($scope.documentId, "Html", 0, 0, null).
                                then(function (data) {
                                    deferred.resolve(data);
                                    $scope.building = false;
                                });

                            $interval.cancel(interval);
                        }
                        else {
                            $scope.getDocumentProgress($scope.documentId).
                                then(function (result) {
                                    if (result.progress != -1) $scope.progress = result.progress;
                                    $scope.cancelled = result.cancelled;
                                }, function (reason) {
                                    error = reason;
                                    deferred.reject(reason);
                                    $scope.building = false;
                                });
                        }

                    }, 2000);

                });
            return deferred.promise;
        };

        $scope.getReportDocument = function (id, format, firstPage, lastPage, contentDisposition) {

            var deferred = $q.defer();
            var request = {
                "DocumentId": id,
                "Format": format,
                "FirstPage": firstPage,
                "LastPage": lastPage,
                "ContentDisposition": contentDisposition
            };
            $http({
                "url": rootReportApi + "/document",
                "method": "POST",
                "data": request,
                "headers": {"Content-Type": "application/json"}
            })
                .success(function (data, status, headers, config) {
                    deferred.resolve(data);
                })
                .error(function (data, status, headers, config) {
                    if (status == 401) {
                        deferred.reject();
                    } else {
                        deferred.reject(data);
                    }
                });
            return deferred.promise;
        };

        $scope.getDocumentProgress = function (id) {

            var deferred = $q.defer();
            var request = {
                "DocumentId": id
            };
            $http({
                "url": rootReportApi + "/document/progress/" + encodeURIComponent(id),
                "method": "GET"
            })
                .success(function (data, status, headers, config) {
                    var pages = Array.apply(null, Array(data.pageCount)).map(function (x, i) {
                        return i;
                    });
                    $scope.dataSource.data(pages);
                    $scope.dataSource.page(1);

                    deferred.resolve(data);
                })
                .error(function (data, status, headers, config) {
                    if (status == 401) {
                        deferred.reject();
                    } else {
                        deferred.reject(data);
                    }
                });
            return deferred.promise;
        };

        $scope.cancelDocument = function (id) {

            var deferred = $q.defer();
            var request = {
                "DocumentId": id
            };

            if (id) {
                $http({
                    "url": rootReportApi + "/document/cancel/" + encodeURIComponent(id),
                    "method": "GET"
                })
                    .success(function (data, status, headers, config) {

                    })
                    .error(function (data, status, headers, config) {
                        if (status == 401) {
                            deferred.reject();
                        } else {
                            deferred.reject(data);
                        }
                    }).finally(function () {
                        $scope.cancelled = true;
                    });
            }
            return deferred.promise;
        };

        //And finally trigger the routine that will build and show report
        $scope.onActivate();


        function initStepHeader() {
            $scope.stateDisplayName = "";
            $scope.stateIconName = "";

            return $q.all(
                [
                    usersRepository.getCurrentUser(),
                    workflowRepository.getSteps()
                ]
            ).then(function (data) {
                    var stepDisplayName = "All Items";

                    var isCustomer = data[0].isCustomer();
                    var step = _.find(data[1], function (s) {
                        return s.$model.code === $scope.step;
                    });
                    var stepConfig = _.find($customisationConfig.workflow.steps, function (s) {
                        return s.code === $scope.step;
                    });

                    if (step) {
                        stepDisplayName = isCustomer ? step.$model.publicNameResource : step.$model.nameResource;
                    }

                    var fallbackIconForStep = function (stepCode) {
                        return $customisationConfig.hasResource(function (res) {
                            return _.string.contains(res, stepCode + ".");
                        }) ? stepCode : "workflow";
                    };

                    if ($scope.step && $scope.step !== "all-open") {
                        $scope.stateDisplayName = serverLocalization.translate(stepDisplayName);
                    } else {
                        $scope.stateDisplayName = gettextCatalog.getString("All Items");
                    }
                    $scope.stateIconName = angular.isUndefined(stepConfig) ? fallbackIconForStep($scope.step) :
                        (angular.isDefined(stepConfig.publicImageResourceName) && isCustomer
                            ? stepConfig.publicImageResourceName
                            :
                            (angular.isDefined(stepConfig.imageResourceName) ? stepConfig.imageResourceName :
                                fallbackIconForStep($scope.step)));
                });
        }

        $scope.moveUp = function (documentId) {
            if (documentId && $scope.progress < 100) {
                //Cancel report generation if it's not generated yet
                $scope.cancelDocument(documentId);
            }
            if (reportConfig.backAction) {
                reportConfig.backAction();
            } else {
                $state.go('client.orders', {step: $scope.step});
            }
        }
    })

;
